import Rollbar from 'rollbar';
import { env } from '@/utils/env';

// Rollbar is enabled only when VITE_ROLLBAR_ACCESS_TOKEN is set.
// To disable (e.g. in development), remove the token from your .env file.
export const rollbarConfig = {
  accessToken: env?.VITE_ROLLBAR_ACCESS_TOKEN,
  environment: env?.VITE_NODE_ENV || 'development',
  enabled: !!env?.VITE_ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
};

// Singleton shared across the app (including non-React contexts like fcm/logger.ts).
// main.tsx passes this to <RollbarProvider instance={rollbar}> so useRollbar() returns the same object.
export const rollbar = new Rollbar(rollbarConfig);
